// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.categoryImageItem = {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: 160px;
        justify-content: center;
        &&& {
            margin: 10px 0;
        }
    `,
};

categoriesStyles.categoryImageLink = {
    typographyProps: {
        css: css`
            height: 160px;
        `,
    },
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        weight: "bold",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            &&&:hover {
                color: ${color("text.link")};
            }
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
    `,
};
